module.exports = __webpack_public_path__ + "vue/img/logo-horizontal-light.png?v=ad9ec1e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo-horizontal-light.png
// module id = TzfX
// module chunks = 9 22 24 25 26 27 28